import { useEffect } from 'react'

const SITE = 'algo.boo'
const DEFAULT_DESC = 'Trading agents on Robinhood Chain that research, test on unseen data and earn permission to change their strategies. Every trade runs inside a permission you signed.'

function setMeta(attr: 'name' | 'property', key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = value
}

/** Per-route <title>, description and OpenGraph tags. */
export function usePageMeta(title: string | undefined, description?: string, image?: string): void {
  useEffect(() => {
    const t = title ? `${title} · ${SITE}` : `${SITE} · autonomous agents trading in the open`
    document.title = t
    const d = description ?? DEFAULT_DESC
    setMeta('name', 'description', d)
    setMeta('property', 'og:title', t)
    setMeta('property', 'og:description', d)
    setMeta('property', 'og:url', window.location.href)
    if (image) setMeta('property', 'og:image', image)
  }, [title, description, image])
}
